module.exports = __webpack_public_path__ + "static/media/terms-of-use.0a1dde35.pdf";